import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_UNAUTHENTICATED,
  LOADING_USER,
  UPDATE_USER_CREDENTIALS,
  MARK_NOTIFICATIONS_READ,
  SET_UI_MESSAGE,
  CLEAR_UI_MESSAGE,
  SET_PINTEREST_PROFILES,
  SET_SCHEDULING_SETTINGS,
  SET_SCHEDULED_POSTS,
  SET_SCHEDULED_POST,
  ADD_NEW_SCHEDULED_POST,
  DELETE_SCHEDULED_POST,
  UPDATE_SCHEDULED_POSTS,
  SET_IS_LOADING_SCHEDULED_POSTS,
  SET_REPEATING_POSTS,
  ADD_REPEATING_POSTS,
  SET_REPEATING_POST,
  ADD_NEW_REPEATING_POST,
  DELETE_REPEATING_POST,
  UPDATE_REPEATING_POSTS,
  SET_IS_LOADING_REPEATING_POSTS,
  INCREMENT_USED_POST_CREDITS,
  DECREMENT_USED_POST_CREDITS,
  CLEAR_DATA,
  SET_USER_ACTIVE_PLAN_DETAILS,
  SET_SHOP_PROFILES,
  SET_SELECTED_BOARDS,
  STOP_LOADING_USER,
  SET_USER_PLAN_TO_ACTIVE,
  ADD_USER_MEDIA,
  SET_USER_MEDIA,
  DELETE_USER_MEDIA,
  TOGGLE_TEMPLATE_FAVORITE,
  SET_FAILING_PINTEREST_PROFILES,
  SET_FAILING_AUTHORIZED_PROFILES,
  ADD_SCHEDULED_POSTS,
  SET_SCHEDULED_POSTS_TOTAL_COUNT,
  SET_POSTS,
  SET_DRAFTS,
  APPEND_DRAFTS,
  PREPEND_DRAFT,
  DELETE_DRAFT,
  RENAME_DRAFT,
  SET_ONBOARDING_CHECKLIST,
  // Add new social media types
  SET_SOCIAL_MEDIA_PROFILES,
  SET_ACTIVE_SOCIAL_MEDIA_PROFILES,
  ADD_SOCIAL_MEDIA_PROFILE,
  UPDATE_SOCIAL_MEDIA_PROFILE,
  REMOVE_SOCIAL_MEDIA_PROFILE,
  ACTIVATE_SOCIAL_MEDIA_PROFILE,
  SET_SOCIAL_MEDIA_LOADING,
  SET_BATCH_CONTENT_LOADING,
  SET_UNAUTHORIZED_BATCH_ACCESS,
} from "../types";

import axios from "axios";
import config from "../../utils/config";
const creditUsage = config.creditUsage;
// Pinterest tokens are now managed server-side, no need to import deprecated functions
import { getAllPinterestBoards, setSelectedBoards } from "./dataActions";
import { startPinterestOAuth } from "../../utils/utilityFunctions";
import {
  trackSignUp,
  preparePostForRendering,
} from "../../utils/utilityFunctions";
import { getUserTemplates, clearTemplatesData } from "./templateActions";
import {
  updateSinglePost,
  resetDesignSettings,
  prepareAltText,
  getDesignSettingsProfiles,
} from "./designActions";
import { trackSubscribe } from "../../utils/utilityFunctions";
import { selectPostImages } from "../../components/PostGenerator/postFormattingFunctions";
/**
 * Apply frontend fallbacks for batch posts that are missing templates or colors.
 * Uses the current Redux state to pick from available standard templates and design colors.
 */
function applyBatchPostFallbacks(posts, getState) {
  const state = getState();
  const standardTemplates =
    state.templates?.present?.standardTemplates || [];
  const designColors = state.design?.designColors || [];

  // Check if any posts need fallbacks
  const postsMissingTemplates = posts.filter(
    (p) => !p.template && !p.isAIGeneratedFromReference
  );

  if (postsMissingTemplates.length === 0) {
    return posts; // No fallbacks needed
  }

  console.log(
    `🔧 Applying frontend fallbacks: ${postsMissingTemplates.length} posts missing templates`
  );

  // Group standard templates by platform for efficient lookup
  const templatesByPlatform = {};
  standardTemplates.forEach((t) => {
    const platform = t.platform || "pinterest";
    if (!templatesByPlatform[platform]) templatesByPlatform[platform] = [];
    templatesByPlatform[platform].push(t);
  });

  // Track index per platform for round-robin variety
  const templateIndexByPlatform = {};

  // Assign fallback templates and colors
  let processedPosts = posts.map((post) => {
    // Skip posts that already have templates or are AI reference images
    if (post.template || post.isAIGeneratedFromReference) return post;

    let updatedPost = { ...post };

    // Assign a template - pick from matching platform, round-robin for variety
    if (standardTemplates.length > 0) {
      const platform = post.platform || "pinterest";
      const platformTemplates = templatesByPlatform[platform] || [];
      const availableTemplates =
        platformTemplates.length > 0 ? platformTemplates : standardTemplates;

      if (!templateIndexByPlatform[platform]) {
        templateIndexByPlatform[platform] = 0;
      }
      const idx =
        templateIndexByPlatform[platform] % availableTemplates.length;
      const template = availableTemplates[idx];
      templateIndexByPlatform[platform]++;

      updatedPost.template = template;
      updatedPost.templateType = template.templateId || template.id;
    }

    // Assign a color if missing
    if (!updatedPost.color && designColors.length > 0) {
      const randomColorIndex = Math.floor(
        Math.random() * designColors.length
      );
      updatedPost.colorIndex = randomColorIndex;
      updatedPost.color = designColors[randomColorIndex].color;
    }

    return updatedPost;
  });

  // Apply images to template layers so they render correctly
  try {
    processedPosts = selectPostImages(
      processedPosts,
      false, // isRandomImages
      true, // useAllDetectedImages
      [], // selectedDetectedImages
      [], // selectedUploadedImages
      false, // forceRandomImages
      null // logoImage
    );
  } catch (err) {
    console.warn("⚠️ Error applying images to template layers:", err);
  }

  console.log(
    `✅ Frontend fallbacks applied to ${postsMissingTemplates.length} posts`
  );
  return processedPosts;
}

export const loginUser =
  (userData, mustCloseModal, closeModal) => (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: LOADING_UI });
      axios
        .post("/api/login", userData)
        .then((res) => {
          setAuthorizationHeader(res.data.tokens);

          try {
            dispatch(getUserData());
            dispatch(getUserTemplates("None"));

          } catch (err) {
            console.error("Failed to get user data: ", err);
          }

          dispatch({ type: CLEAR_ERRORS });

          resolve();

          // Close the modal for the login modal
          if (mustCloseModal == true) {
            closeModal();
          } else {
            // Check if there's a redirect URL stored for batch content access
            const redirectAfterLogin =
              localStorage.getItem("redirectAfterLogin");
            if (redirectAfterLogin) {
              localStorage.removeItem("redirectAfterLogin");
              window.location.href = redirectAfterLogin;
              return;
            }

            // The the previous page is not https://www.pinterest.com/oauth/... then go back
            // Else go to the home page
            // This prevents the user from being stuck on the pinterest oAuth page loop

            let previousPage = document.referrer;
            if (
              previousPage.includes("pinterest.com/oauth/") ||
              previousPage.includes("/signup") ||
              previousPage.includes("/login")
            ) {
              window.location.href = "/";
            } else {
              window.history.back();
            }
          }
        })
        .catch((err) => {
          console.error(err);
          dispatch({
            type: SET_ERRORS,
            payload: err.response.data,
          });
        });
    });
  };

export const forgotPassword = (email) => (dispatch) => {
  dispatch({ type: LOADING_UI });
  axios
    .post("/api/user/forgotPassword", { email })
    .then((res) => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({
        type: SET_UI_MESSAGE,
        payload: "Password reset requested for this email",
      });
    })
    .catch((err) => {
      dispatch({ type: CLEAR_UI_MESSAGE });
      dispatch({
        type: SET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const signupUser =
  (newUserData, mustCloseModal, closeModal, recaptcha) => async (dispatch) => {
    dispatch({ type: LOADING_UI });

    // Get users IP address
    fetch("https://api.ipify.org?format=json")
      .then((results) => results.json())
      .then((data) => {
        return axios.post("/api/signup", { ...newUserData, ip: data.ip });
      })
      .then((res) => {
        setAuthorizationHeader(res.data.tokens);
        dispatch(getUserData());
        dispatch({ type: CLEAR_ERRORS });

        // Get users IP address
        trackSignUp(newUserData.email);

        if (mustCloseModal == true) {
          closeModal();
        } else {
          // Check if there's a redirect URL stored (e.g., for founding partner flow)
          const redirectAfterLogin = localStorage.getItem("redirectAfterLogin");
          if (redirectAfterLogin) {
            localStorage.removeItem("redirectAfterLogin");
            window.location.href = redirectAfterLogin;
            return;
          }

          alert("Please check your email to verify your account");

          // Navigate to the onboarding page
          window.location.href = "/onboarding";
        }
      })
      .catch((err) => {
        console.error(err);
        dispatch({
          type: SET_ERRORS,
          payload: err.response.data,
        });

        // Reset recaptcha
        recaptcha.current.reset();
      });
  };

export const signInWithGoogle =
  (newUserData, mustCloseModal, closeModal, tokens) => async (dispatch) => {
    dispatch({ type: LOADING_UI });

    // Get users IP address
    fetch("https://api.ipify.org?format=json")
      .then((results) => results.json())
      .then((data) => {
        return axios.post("/api/signInWithGoogle", {
          ...newUserData,
          ip: data.ip,
        });
      })
      .then((res) => {
        setAuthorizationHeader(tokens);
        dispatch(getUserData());
        dispatch({ type: CLEAR_ERRORS });

        // If 201 signup
        // Track the signup
        // Redirect to onboarding
        if (res.status == 201) {
          trackSignUp(newUserData.email);

          if (mustCloseModal == true) {
            closeModal();

            showOnboardingAlert();
          } else {
            // Check if there's a redirect URL stored (e.g., for founding partner flow)
            const redirectAfterLogin =
              localStorage.getItem("redirectAfterLogin");
            if (redirectAfterLogin) {
              localStorage.removeItem("redirectAfterLogin");
              window.location.href = redirectAfterLogin;
              return;
            }

            // Navigate to the onboarding page
            window.location.href = "/onboarding";
          }
        } else {
          // User is logging in

          if (mustCloseModal == true) {
            closeModal();
          } else {
            // Check if there's a redirect URL stored for batch content access
            const redirectAfterLogin =
              localStorage.getItem("redirectAfterLogin");
            if (redirectAfterLogin) {
              localStorage.removeItem("redirectAfterLogin");
              window.location.href = redirectAfterLogin;
              return;
            }

            // The the previous page is not https://www.pinterest.com/oauth/... or contentgenerator.io/signup or contentgenerator.io/lgin then go back
            // Else go to the home page
            // This prevents the user from being stuck on the pinterest oAuth page loop

            let previousPage = document.referrer;
            if (
              previousPage.includes("pinterest.com/oauth/") ||
              previousPage.includes("/signup") ||
              previousPage.includes("/login")
            ) {
              window.location.href = "/";
            } else {
              window.history.back();
            }
          }
        }
      })
      .catch((err) => {
        console.error(err);
        dispatch({
          type: SET_ERRORS,
          payload: err.response.data,
        });
      });
  };

function showOnboardingAlert() {
  const userResponse = confirm("Would you like to view the onboarding page?");

  if (userResponse === true) {
    // User clicked "Yes"
    window.location.href = "/onboarding"; // Replace with the URL of your onboarding page
  } else if (userResponse === false) {
    // User clicked "No" or "Cancel"
    // Stay on the current page
  } else {
    // User clicked outside the alert
    // Stay on the current page
  }
}

// This logs a user out but maintains design settings
// Useful for when a FBToken expires and we need to reauthenticate
export const softLogoutUser = () => (dispatch) => {
  localStorage.removeItem("FBIdToken");
  localStorage.removeItem("FBRefreshToken");

  // Pinterest tokens are now managed server-side - no client cleanup needed

  localStorage.removeItem("ShopifyAuthDetails");

  delete axios.defaults.headers.common["Authorization"];
  dispatch({ type: SET_UNAUTHENTICATED }); // User
};

export const logoutUser = () => (dispatch) => {
  localStorage.removeItem("FBIdToken");
  localStorage.removeItem("FBRefreshToken");

  // Pinterest tokens are now managed server-side - no client cleanup needed

  localStorage.removeItem("ShopifyAuthDetails");

  delete axios.defaults.headers.common["Authorization"];
  dispatch({ type: SET_UNAUTHENTICATED }); // User

  // TURNED OFF as users who had an issue requthenticating woudl have this cleared and lose all their design posts
  dispatch({ type: CLEAR_DATA }); // Data
  dispatch(clearTemplatesData()); // Templates
  dispatch(resetDesignSettings()); // Design
};

export const getUserData = () => (dispatch) => {
  dispatch({ type: LOADING_USER });

  axios
    .get("/api/user")
    .then((res) => {
      dispatch({
        type: SET_USER,
        payload: res.data,
      });

      // Load design settings profiles immediately after user data is loaded
      // This ensures designProfilesLoaded becomes true for batch content loading
      if (res.data.credentials.handle) {
        dispatch(getDesignSettingsProfiles(res.data.credentials.handle)).catch(
          (err) => {
            console.warn("Failed to load design settings profiles:", err);
          }
        );
      }

      // if the user has authorized social media profiles (specifically Pinterest)
      // And we are not currently reauthenticating a social media account
      if (
        res.data.credentials.authorizedSocialMediaProfiles?.pinterest &&
        res.data.credentials.authorizedSocialMediaProfiles.pinterest.length >
          0 &&
        !window.location.href.includes("code=") &&
        !window.location.href.includes("state=")
      ) {
        // Set up client-side state for the active Pinterest profile WITHOUT calling backend activation
        const activePinterestProfile =
          res.data.credentials.activeSocialMediaProfiles?.pinterest;
        if (activePinterestProfile) {
          try {
            // Find the active profile data
            const activeProfileData =
              res.data.credentials.authorizedSocialMediaProfiles.pinterest.find(
                (profile) => profile.username === activePinterestProfile
              );

            if (activeProfileData && activeProfileData.authToken) {
              // Pinterest tokens are now managed server-side, no client-side setup needed

              // Add a small delay to avoid race condition with OAuth callback
              // Only load boards if we're not coming from OAuth (no redirect URL in localStorage)
              const isReturningFromOAuth =
                localStorage.getItem("oauthRedirectUrl");

              if (!isReturningFromOAuth) {
                // Load Pinterest boards for the active profile with retry logic
                setTimeout(() => {
                  dispatch(getAllPinterestBoards()).catch((err) => {
                    console.warn(
                      "Failed to load Pinterest boards on page load:",
                      err
                    );

                    // If it's a 401 error, retry once after a longer delay
                    if (err.response?.status === 401) {
                      console.log(
                        "Retrying Pinterest boards load after authentication delay..."
                      );
                      setTimeout(() => {
                        dispatch(getAllPinterestBoards()).catch((retryErr) => {
                          console.warn(
                            "Pinterest boards retry also failed:",
                            retryErr
                          );
                        });
                      }, 2000);
                    }
                  });
                }, 500);
              }
            }
          } catch (err) {
            console.warn("Failed to set up Pinterest client state:", err);
          }
        }
      }

      // Set the consent cookie
      if (typeof res.data.credentials.cookiesConsent !== "undefined") {
        localStorage.setItem(
          "cookiesConsent",
          res.data.credentials.cookiesConsent
        );
      }
    })
    .catch((err) => {
      console.error(err);
      dispatch({ type: SET_ERRORS, payload: err });
    });
};

const setAuthorizationHeader = (tokens) => {
  // Set idToken
  const FBIdToken = `Bearer ${tokens.idToken}`;
  localStorage.setItem("FBIdToken", FBIdToken);
  axios.defaults.headers.common["Authorization"] = FBIdToken;

  // Set refreshToken
  const FBRefreshToken = tokens.refreshToken;
  localStorage.setItem("FBRefreshToken", FBRefreshToken);
};

export const getFailingAuthorizedProfiles = () => (dispatch) => {
  axios
    .get("/api/socialMedia/failingProfiles")
    .then((res) => {
      dispatch({
        type: SET_FAILING_AUTHORIZED_PROFILES,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.error(
        "Error getting failing authorized profiles: ",
        err.response.data
      );
    });
};

export const uploadImage = (formData) => (dispatch) => {
  dispatch({ type: LOADING_USER });

  axios
    .post("/api/user/image", formData)
    .then((res) => {
      dispatch(getUserData());
    })
    .catch((err) => {
      console.error(err.response.data);
      dispatch({ type: SET_ERRORS, payload: err.response.data });
    });
};

export const editUserDetails = (updates) => (dispatch) => {
  dispatch({ type: LOADING_USER });
  axios
    .post("/api/user", { updates: updates })
    .then(() => {
      dispatch({ type: UPDATE_USER_CREDENTIALS, payload: updates });
      dispatch({ type: STOP_LOADING_USER });
    })
    .catch((err) => {
      dispatch({ type: SET_ERRORS, payload: err });
      console.error(err);
    });
};

export const markNotificationsRead = (notificationIds) => (dispatch) => {
  axios
    .post("api/notifications", notificationIds)
    .then((res) => {
      dispatch({
        type: MARK_NOTIFICATIONS_READ,
      });
    })
    .catch((err) => console.error(err));
};

export const activateUserSubscription = (userDetails) => (dispatch) => {
  dispatch({ type: LOADING_USER });
  axios
    .post("/api/subscriptions/activateUserSubscription", userDetails)
    .then(() => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch(getUserData());
    })
    .catch((err) => {
      dispatch({ type: SET_ERRORS, payload: err });
      console.error(err);
    });
};

export const cancelUserSubscription =
  (subscriptionID, setErrorMessage, setSuccessMessage, cancelReason) =>
  (dispatch) => {
    dispatch({ type: LOADING_USER });

    return new Promise((resolve, reject) => {
      axios
        .post("/api/subscriptions/cancelSubscription", {
          subscriptionID,
          cancelReason,
        })
        .then(() => {
          dispatch({ type: CLEAR_ERRORS });
          dispatch(getUserData());
          if (setErrorMessage) setErrorMessage("");
          if (setSuccessMessage)
            setSuccessMessage("Your subscription has been canceled");
          resolve();
        })
        .catch((err) => {
          if (setErrorMessage)
            setErrorMessage(
              `There was an error cancelling your subscription. ${err}`
            );
          dispatch({ type: SET_ERRORS, payload: err });
          reject();
        });
    });
  };

export const suspendUserSubscription =
  (subscriptionID, setErrorMessage, setSuccessMessage) => (dispatch) => {
    dispatch({ type: LOADING_USER });
    axios
      .post("/api/subscriptions/suspendSubscription", {
        subscriptionID: subscriptionID,
      })
      .then(() => {
        dispatch({ type: CLEAR_ERRORS });
        dispatch(getUserData());
        setErrorMessage("");
        setSuccessMessage("Your subscription has been suspended");
      })
      .catch((err) => {
        setErrorMessage(
          `There was an error suspending your subscription. ${err}`
        );
        dispatch({ type: SET_ERRORS, payload: err });
      });
  };

export const reactivateUserSubscription =
  (subscriptionID, setErrorMessage, setSuccessMessage) => (dispatch) => {
    dispatch({ type: LOADING_USER });
    axios
      .post("/api/subscriptions/reactivateSubscription", {
        subscriptionID: subscriptionID,
      })
      .then(() => {
        dispatch({ type: CLEAR_ERRORS });
        dispatch(getUserData());
        setErrorMessage("");
        setSuccessMessage("Your subscription has been re-activated");
      })
      .catch((err) => {
        setErrorMessage(
          `There was an error re-activating your subscription. ${err}`
        );
        dispatch({ type: SET_ERRORS, payload: err });
      });
  };

export const incrementUsedPostCredits =
  (creditAmount = 1, category) =>
  (dispatch) => {
    if (!category) {
      console.error("Credit category is required for incrementUsedPostCredits");
      return;
    }

    axios
      .post("/api/user/incrementUsedPostCredits", { creditAmount, category })
      .then(() => {
        dispatch(incrementUsedPostCreditsInReduxState(creditAmount));
      })
      .catch((err) => {
        console.error("Unable to increment used post credits: ", err);
        dispatch({ type: SET_ERRORS, payload: err });
      });
  };

export const adjustCredits =
  (postDetails, numCreditsToConsume, category) => (dispatch) => {
    if (!category) {
      console.error("Credit category is required for adjustCredits");
      return;
    }

    axios
      .post("/api/scraping/adjustCredits", {
        postDetails,
        numCreditsToConsume,
        category,
      })
      .then(() => {
        dispatch(incrementUsedPostCreditsInReduxState(numCreditsToConsume));
      })
      .catch((err) => {
        console.error(
          "Unable to create post history and adjust credits: ",
          err
        );
        dispatch({ type: SET_ERRORS, payload: err });
      });
  };

export const incrementUsedPostCreditsInReduxState =
  (numCredits) => (dispatch) => {
    dispatch({ type: INCREMENT_USED_POST_CREDITS, payload: numCredits });
  };

export const decrementUsedPostCreditsInReduxState = () => (dispatch) => {
  dispatch({ type: DECREMENT_USED_POST_CREDITS });
};

// Pinterest API functions

export const refreshPinterestAccessToken = () => (dispatch) => {
  // DEPRECATED: Pinterest tokens are now managed server-side
  console.warn(
    "refreshPinterestAccessToken is deprecated - Pinterest tokens are managed server-side"
  );
  return new Promise((resolve) => {
    resolve("Pinterest tokens are now managed server-side");
  });
};

// SOCIAL MEDIA PROFILE ACTIONS

// Set social media profiles for all platforms
export const setSocialMediaProfiles = (profiles) => (dispatch) => {
  dispatch({
    type: SET_SOCIAL_MEDIA_PROFILES,
    payload: profiles,
  });
};

// Set active social media profiles
export const setActiveSocialMediaProfiles = (activeProfiles) => (dispatch) => {
  dispatch({
    type: SET_ACTIVE_SOCIAL_MEDIA_PROFILES,
    payload: activeProfiles,
  });
};

// Add a new social media profile
export const addSocialMediaProfile = (platform, profile) => (dispatch) => {
  dispatch({
    type: ADD_SOCIAL_MEDIA_PROFILE,
    payload: { platform, profile },
  });
};

// Update an existing social media profile
export const updateSocialMediaProfile = (platform, profile) => (dispatch) => {
  dispatch({
    type: UPDATE_SOCIAL_MEDIA_PROFILE,
    payload: { platform, profile },
  });
};

// Remove a social media profile
export const removeSocialMediaProfile = (platform, username) => (dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch({
      type: SET_SOCIAL_MEDIA_LOADING,
      payload: { platform, username, loading: true },
    });

    axios
      .delete(`/api/socialMedia/${platform}/profile`, {
        data: { username },
      })
      .then((res) => {
        dispatch({
          type: REMOVE_SOCIAL_MEDIA_PROFILE,
          payload: { platform, username },
        });

        dispatch({
          type: SET_SOCIAL_MEDIA_LOADING,
          payload: { platform, username, loading: false },
        });
        resolve(res.data);
      })
      .catch((err) => {
        console.error(`Remove ${platform} profile error:`, err);
        dispatch({
          type: SET_SOCIAL_MEDIA_LOADING,
          payload: { platform, username, loading: false },
        });

        const errorMessage =
          err.response?.data?.message || `Failed to remove ${platform} profile`;
        reject(new Error(errorMessage));
      });
  });
};

// Activate a social media profile
export const activateSocialMediaProfile =
  (platform, username, userHandle) => (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SET_SOCIAL_MEDIA_LOADING,
        payload: { platform, username, loading: true },
      });

      axios
        .put(`/api/socialMedia/${platform}/profile/activate`, {
          username,
        })
        .then((res) => {
          dispatch({
            type: ACTIVATE_SOCIAL_MEDIA_PROFILE,
            payload: { platform, username, data: res.data },
          });

          // Pinterest tokens are now managed server-side, no client-side token updates needed
          if (platform === "pinterest" && res.data.profileData) {
            // Clear all selected boards from redux state
            dispatch(setSelectedBoards([]));

            // Refresh Pinterest boards for the newly activated profile
            dispatch(getAllPinterestBoards()).catch((err) => {
              console.warn(
                "Failed to load boards for activated Pinterest profile:",
                err
              );
            });
          }

          dispatch({
            type: SET_SOCIAL_MEDIA_LOADING,
            payload: { platform, username, loading: false },
          });

          resolve(res.data);
        })
        .catch((err) => {
          console.error(`Activate ${platform} profile error:`, err);
          dispatch({
            type: SET_SOCIAL_MEDIA_LOADING,
            payload: { platform, username, loading: false },
          });

          const errorMessage =
            err.response?.data?.message ||
            `Failed to activate ${platform} profile`;
          reject(new Error(errorMessage));
        });
    });
  };

// Get social media profiles for a user
export const getSocialMediaProfiles =
  (platform = null) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      const url = platform
        ? `/api/socialMedia/profiles?platform=${platform}`
        : `/api/socialMedia/profiles`;

      axios
        .get(url)
        .then((res) => {
          if (platform) {
            dispatch(updateSocialMediaProfile(platform, res.data));
          } else {
            dispatch(setSocialMediaProfiles(res.data));
          }
          resolve(res.data);
        })
        .catch((err) => {
          console.error("Get social media profiles error:", err);
          reject(err);
        });
    });
  };

// BACKWARD COMPATIBILITY - Pinterest-specific actions
export const activatePinterestProfile =
  (username, userHandle) => (dispatch) => {
    // Use the generic action but maintain the same interface
    return dispatch(
      activateSocialMediaProfile("pinterest", username, userHandle)
    );
  };

export const removePinterestProfile = (username) => (dispatch) => {
  // Use the generic action but maintain the same interface
  return dispatch(removeSocialMediaProfile("pinterest", username));
};

// Update the existing getUserData function to handle new social media structure
// ... (keep existing getUserData function but modify to handle both old and new structures)

// Shops functions
export const removeShopProfile = (shopID) => (dispatch) => {
  dispatch({ type: LOADING_USER });
  axios
    .delete(`/api/etsyAPI/removeShopProfile/${shopID}`)
    .then((res) => {
      dispatch({
        type: SET_SHOP_PROFILES,
        payload: res.data,
      });
      dispatch({ type: STOP_LOADING_USER });
    })
    .catch((err) => {
      console.error("Failed to remove shop profile: ", err);
      dispatch({ type: SET_ERRORS, payload: err });
    });
};

export const setShopProfiles = (shopProfiles) => (dispatch) => {
  dispatch({
    type: SET_SHOP_PROFILES,
    payload: shopProfiles,
  });
};

export const setAnonymousShopifyStoreAuthDetails =
  (authDetails) => (dispatch) => {
    dispatch({
      type: SET_SHOP_PROFILES,
      payload: { anonymous: { authDetails } },
    });
  };

// Scheduling functions

export const getSchedulingSettingsForProfile =
  (platform, socialMediaProfileUsername) => (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/scheduling/getSchedulingSettingsForProfile", {
          platform,
          socialMediaProfileUsername,
        })
        .then((res) => {
          dispatch({
            type: SET_SCHEDULING_SETTINGS,
            payload: res.data,
          });
          resolve(res.data);
        })
        .catch((err) => {
          console.error("Failed to get scheduling settings for profile", err);
          dispatch({ type: SET_ERRORS, payload: err });
          reject(err);
        });
    });
  };

export const saveSchedulingSettings = (newSettings) => (dispatch) => {
  axios
    .post("/api/scheduling/saveSchedulingSettings", {
      newSettings,
    })
    .then((res) => {
      dispatch({
        type: SET_SCHEDULING_SETTINGS,
        payload: newSettings,
      });
    })
    .catch((err) => {
      console.error("Failed save scheduling settings ", err);
      dispatch({ type: SET_ERRORS, payload: err });
    });
};

export const getScheduledPosts =
  (
    lastPostId = "None",
    sortBy = "scheduledTimeUTCTimestamp-asc",
    platformFilter = "all",
    profileFilter = "all"
  ) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      // Clear posts if we are starting from the beginning
      if (lastPostId == "None") {
        dispatch({
          type: SET_SCHEDULED_POSTS,
          payload: [],
        });
      }

      // Prepare profile filter - convert array to comma-separated string if needed
      const profilesParam = Array.isArray(profileFilter)
        ? profileFilter.join(",")
        : profileFilter;

      axios
        .get(`/api/scheduling/getScheduledPosts`, {
          params: {
            lastPostId: lastPostId,
            sortBy: sortBy,
            platform: platformFilter, // Platform filter parameter
            profiles: profilesParam, // Profile filter parameter
          },
        })
        .then((res) => {
          // Defensive programming: check if res and res.data exist
          if (!res || !res.data) {
            console.error(
              "Invalid response structure from getScheduledPosts:",
              res
            );
            reject(new Error("Invalid response structure"));
            return;
          }

          let { scheduledPosts, totalCount, lastPostScheduledTime } = res.data;

          // Ensure scheduledPosts is an array
          if (!Array.isArray(scheduledPosts)) {
            console.warn(
              "scheduledPosts is not an array, defaulting to empty array"
            );
            scheduledPosts = [];
          }

          if (totalCount !== undefined && totalCount !== null) {
            dispatch({
              type: SET_SCHEDULED_POSTS_TOTAL_COUNT,
              payload: totalCount,
            });
          }

          if (lastPostId == "None") {
            dispatch({
              type: SET_SCHEDULED_POSTS,
              payload: scheduledPosts,
            });
          } else {
            dispatch({
              type: ADD_SCHEDULED_POSTS,
              payload: scheduledPosts,
            });
          }

          resolve({ scheduledPosts, totalCount, lastPostScheduledTime });
        })
        .catch((err) => {
          console.error("Error getting scheduled posts: ", err);
          reject(err);
        });
    });
  };

export const getScheduledPostsByMonth =
  (year, month, platformFilter = "all", profileFilter = "all") =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      // Prepare profile filter - convert array to comma-separated string if needed
      const profilesParam = Array.isArray(profileFilter)
        ? profileFilter.join(",")
        : profileFilter;

      axios
        .get(`/api/scheduling/getScheduledPostsByMonth`, {
          params: {
            year: year,
            month: month,
            platform: platformFilter,
            profiles: profilesParam,
          },
        })
        .then((res) => {
          // Defensive programming: check if res and res.data exist
          if (!res || !res.data) {
            console.error(
              "Invalid response structure from getScheduledPostsByMonth:",
              res
            );
            reject(new Error("Invalid response structure"));
            return;
          }

          let { scheduledPosts, totalCount } = res.data;

          // Ensure scheduledPosts is an array
          if (!Array.isArray(scheduledPosts)) {
            console.warn(
              "scheduledPosts is not an array, defaulting to empty array"
            );
            scheduledPosts = [];
          }

          // For calendar view, we replace all posts with the month's posts
          dispatch({
            type: SET_SCHEDULED_POSTS,
            payload: scheduledPosts,
          });

          if (totalCount !== undefined && totalCount !== null) {
            dispatch({
              type: SET_SCHEDULED_POSTS_TOTAL_COUNT,
              payload: totalCount,
            });
          }

          resolve({ scheduledPosts, totalCount });
        })
        .catch((err) => {
          console.error("Error getting scheduled posts by month: ", err);
          reject(err);
        });
    });
  };

export const updateScheduledPost =
  (post, originalPost = null) =>
  (dispatch, getState) => {
    // Optimistically update the post immediately for instant UI feedback
    dispatch({
      type: SET_SCHEDULED_POST,
      payload: post,
    });

    // Make the API call to persist the change
    return axios
      .post(`/api/scheduling/updateScheduledPost`, { post })
      .then((res) => {
        // Server update succeeded - post is already optimistically updated
        console.log("Successfully updated scheduled post:", post.id);
      })
      .catch((err) => {
        console.error("Error updating scheduled post: ", err);

        // Post was already published/removed server-side while the user still had it open
        if (err.response?.status === 404) {
          dispatch({
            type: DELETE_SCHEDULED_POST,
            payload: post.id,
          });
        } else if (originalPost) {
          console.log(
            "Rolling back post update due to error:",
            originalPost.id
          );
          dispatch({
            type: SET_SCHEDULED_POST,
            payload: originalPost,
          });
        } else {
          console.warn(
            "No original post provided for rollback. Consider refetching posts."
          );
        }

        throw err;
      });
  };

export const resetScheduledTimes = (profilesToReset) => (dispatch) => {
  return new Promise((resolve, reject) => {
    // Handle backward compatibility - if called with old parameters
    if (typeof profilesToReset === "string") {
      // Old format: resetScheduledTimes(platform, socialMediaProfileUsername)
      const platform = profilesToReset;
      const socialMediaProfileUsername = arguments[1];

      console.warn(
        "Using deprecated resetScheduledTimes format. Please update to use profile array."
      );

      axios
        .post(
          `/highMemLimitApi/scheduling/resetScheduledTimes/${socialMediaProfileUsername}`,
          {
            platform: platform,
            socialMediaProfileUsername: socialMediaProfileUsername,
          }
        )
        .then((res) => {
          dispatch({
            type: SET_SCHEDULED_POSTS,
            payload: [],
          });
          resolve();
        })
        .catch((err) => {
          console.error("Failed to reset posts scheduled times: ", err);
          reject("Failed to reset posts scheduled times: ", err);
        });
      return;
    }

    // New format: resetScheduledTimes([{platform, username}, ...])
    if (!Array.isArray(profilesToReset) || profilesToReset.length === 0) {
      reject(new Error("profilesToReset must be a non-empty array"));
      return;
    }

    console.log(
      `Resetting scheduled times for ${profilesToReset.length} profiles:`,
      profilesToReset
    );

    axios
      .post(`/highMemLimitApi/scheduling/resetScheduledTimes`, {
        profilesToReset: profilesToReset,
      })
      .then((res) => {
        dispatch({
          type: SET_SCHEDULED_POSTS,
          payload: [],
        });
        resolve();
      })
      .catch((err) => {
        console.error("Failed to reset posts scheduled times: ", err);
        reject("Failed to reset posts scheduled times: ", err);
      });
  });
};

// Give an array of scheduled posts with postId to be updated on the database
export const updateScheduledPosts =
  (socialMediaProfileUsername, postsToUpdate, originalPosts = null) =>
  (dispatch, getState) => {
    // Optimistically update the posts immediately for instant UI feedback
    dispatch({
      type: UPDATE_SCHEDULED_POSTS,
      payload: postsToUpdate,
    });

    return new Promise((resolve, reject) => {
      axios
        .post(`/api/scheduling/updateScheduledPosts`, {
          socialMediaProfileUsername: socialMediaProfileUsername,
          postsToUpdate,
        })
        .then((res) => {
          // Server update succeeded - posts are already optimistically updated
          console.log(
            `Successfully updated ${postsToUpdate.length} scheduled posts`
          );
          resolve("Updated posts successfully");
        })
        .catch((err) => {
          console.error("Unable to update scheduled posts: ", err);

          // Rollback to original posts if available
          if (originalPosts && originalPosts.length > 0) {
            console.log(
              `Rolling back ${originalPosts.length} posts due to error`
            );
            dispatch({
              type: UPDATE_SCHEDULED_POSTS,
              payload: originalPosts,
            });
          } else {
            console.warn(
              "No original posts provided for rollback. Consider refetching posts."
            );
          }

          reject("Unable to update scheduled posts: ", err);
        });
    });
  };

export const addPostToScheduledPosts = (newScheduledPost) => (dispatch) => {
  dispatch({
    type: ADD_NEW_SCHEDULED_POST,
    payload: newScheduledPost,
  });
};

export const deletePost = (postId) => (dispatch) => {
  axios
    .post("/api/scheduling/deleteScheduledPost", { postId })
    .then((res) => {
      dispatch({
        type: DELETE_SCHEDULED_POST,
        payload: postId,
      });
    })
    .catch((err) => {
      console.error("Unable to delete post");
    });
};

export const deleteAllScheduledPosts = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/highMemLimitApi/scheduling/deleteAllScheduledPosts", {})
      .then((res) => {
        dispatch({
          type: SET_SCHEDULED_POSTS,
          payload: [],
        });

        resolve("Deleted all scheduled posts successfully");
      })
      .catch((err) => {
        console.error("Unable to delete all scheduled posts: ", err);
        reject("Unable to delete all scheduled posts: ", err);
      });
  });
};

export const setScheduledPosts = (scheduledPosts) => (dispatch) => {
  dispatch({
    type: SET_SCHEDULED_POSTS,
    payload: scheduledPosts,
  });
};

export const getUsersActivePlan = (planId) => (dispatch) => {
  // Get current plan
  dispatch({ type: LOADING_USER });
  axios
    .get(`/api/subscriptions/getPlan/${planId}`)
    .then((planRes) => {
      dispatch({ type: SET_USER_ACTIVE_PLAN_DETAILS, payload: planRes.data });
      dispatch({ type: STOP_LOADING_USER });
    })
    .catch((err) => {
      console.error("Unable to get user active plan details: ", err);
      dispatch({ type: SET_ERRORS, payload: err });
      dispatch({ type: STOP_LOADING_USER });
    });
};

export const startStripeSubscription =
  (subDetails, setErrorAlertText) => (dispatch) => {
    dispatch({ type: LOADING_USER });
    axios
      .post("/api/stripeSubscriptions/startStripeSubscription", subDetails)
      .then((res) => {
        // handle 200 from response
        if (res.status === 200) {
          const redirectUrl = res.data.redirectUrl;

          dispatch({ type: CLEAR_ERRORS });
          window.open(
            `${redirectUrl}`,
            config.configName == "Test" ? "_blank" : "_self"
          );
        } else {
          dispatch({
            type: SET_ERRORS,
            payload: "There was an error activating your subscription.",
          });
          setErrorAlertText("There was an error activating your subscription.");
        }
      })
      .catch((err) => {
        console.error(err);
        dispatch({
          type: SET_ERRORS,
          payload: err,
        });
      });
  };

export const activateStripeSubscription =
  (session_id, affiliateID) => (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/stripeSubscriptions/activateStripeSubscription", {
          session_id,
          affiliateID,
        })
        .then((res) => {
          let { profileUpdates, paymentDetails } = res.data;

          dispatch({ type: SET_USER_PLAN_TO_ACTIVE, payload: profileUpdates });
          resolve(paymentDetails);
        })
        .catch((err) => {
          console.error("Unable to activate shopify subscription: ", err);
          dispatch({ type: SET_ERRORS, payload: err });
          reject();
        });
    });
  };

export const cancelStripeSubscription =
  (subscriptionID, setErrorMessage, setSuccessMessage, cancelReason) =>
  (dispatch) => {
    dispatch({ type: LOADING_USER });

    return new Promise((resolve, reject) => {
      axios
        .post("/api/stripeSubscriptions/cancelStripeSubscription", {
          subscriptionID,
          cancelReason,
        })
        .then((res) => {
          dispatch({ type: CLEAR_ERRORS });
          dispatch(getUserData());
          if (setErrorMessage) setErrorMessage("");
          if (setSuccessMessage)
            setSuccessMessage("Your subscription has been canceled");
          resolve();
        })
        .catch((err) => {
          if (setErrorMessage)
            setErrorMessage(
              `There was an error cancelling your subscription. ${err}`
            );
          console.error("Unable to cancel stripe subscription: ", err);
          dispatch({ type: SET_ERRORS, payload: err });
          reject();
        });
    });
  };

export const reviseStripeSubscription =
  (
    subscriptionID,
    newStripePriceID,
    newPlanId,
    setErrorMessage,
    setSuccessMessage
  ) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/stripeSubscriptions/reviseStripeSubscription", {
          subscriptionID,
          newStripePriceID,
          newPlanId,
        })
        .then((res) => {
          dispatch(getUserData());
          setErrorMessage("");

          setSuccessMessage("Your subscription has been switched");
          resolve();
        })
        .catch((err) => {
          setErrorMessage(`Error switching plan. ${err.response.data.error}`);
          console.error("Unable to revise stripe subscription: ", err);
          dispatch({ type: SET_ERRORS, payload: err });
          reject();
        });
    });
  };

export const startShopifySubscription =
  (subDetails, setErrorAlertText) => (dispatch) => {
    dispatch({ type: LOADING_USER });
    axios
      .post("/api/shopifySubscriptions/startSubscription", subDetails)
      .then((res) => {
        if (res.status === 200) {
          dispatch({ type: CLEAR_ERRORS });
          window.open(
            `${res.data.confirmationUrl}`,
            config.configName == "Test" ? "_blank" : "_self"
          );
        } else {
          dispatch({
            type: SET_ERRORS,
            payload: "There was an error activating your subscription.",
          });
          setErrorAlertText("There was an error activating your subscription.");
        }
      })
      .catch((err) => {
        console.error(err);
        dispatch({
          type: SET_ERRORS,
          payload: err,
        });
      });
  };

export const activateShopifySubscription =
  (chargeId, userEmail) => (dispatch) => {
    axios
      .post("/api/shopifySubscriptions/activateShopifySubscription", {
        chargeId,
      })
      .then((res) => {
        let profileUpdates = res.data;

        trackSubscribe(res.data.planName, res.data.amount, userEmail);

        dispatch({ type: SET_USER_PLAN_TO_ACTIVE, payload: profileUpdates });
      })
      .catch((err) => {
        console.error("Unable to activate shopify subscription: ", err);
        dispatch({ type: SET_ERRORS, payload: err });
      });
  };

export const cancelShopifySubscription =
  (subscriptionID, setErrorMessage, setSuccessMessage, cancelReason) =>
  (dispatch) => {
    dispatch({ type: LOADING_USER });

    return new Promise((resolve, reject) => {
      axios
        .post("/api/shopifySubscriptions/cancelShopifySubscription", {
          subscriptionID,
          cancelReason,
        })
        .then((res) => {
          dispatch({ type: CLEAR_ERRORS });
          dispatch(getUserData());
          if (setErrorMessage) setErrorMessage("");
          if (setSuccessMessage)
            setSuccessMessage("Your subscription has been canceled");
          resolve();
        })
        .catch((err) => {
          if (setErrorMessage)
            setErrorMessage(
              `There was an error cancelling your subscription. ${err}`
            );
          console.error("Unable to cancel shopify subscription: ", err);
          dispatch({ type: SET_ERRORS, payload: err });
          reject();
        });
    });
  };

export const redeemPurchaseCode = (redemptionCode) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/subscriptions/redeemPurchaseCode", {
        redemptionCode,
      })
      .then((res) => {
        dispatch({ type: CLEAR_ERRORS });
        dispatch(getUserData());
        resolve();
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.error) {
          reject(err.response.data.error);
        } else {
          reject("There was an error redeeming your code");
        }
        console.error("Unable to redeem purchase code: ", err.response.data);
        dispatch({ type: SET_ERRORS, payload: err.response.data });
      });
  });
};

export const updateUserCredentials = (updatedCredentials) => (dispatch) => {
  dispatch({ type: UPDATE_USER_CREDENTIALS, payload: updatedCredentials });
};

export const addUserMedia = (mediaArray) => (dispatch) => {
  dispatch({ type: ADD_USER_MEDIA, payload: mediaArray });
};

export const getUserMedia =
  (mediaType, lastMediaId = "None") =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      // mediaType options: "all", "image"
      axios
        .get(`/api/user/media/getUserMedia`, {
          params: { mediaType: mediaType, lastMediaId: lastMediaId },
        })
        .then((res) => {
          let userMedia = res.data;

          dispatch({ type: SET_USER_MEDIA, payload: userMedia });
          resolve(userMedia);
        })
        .catch((err) => {
          console.error("Unable to get user media: ", err);

          dispatch({ type: SET_ERRORS, payload: err });
          reject(err);
        });
    });
  };

export const deleteMedia = (id) => (dispatch) => {
  dispatch({ type: DELETE_USER_MEDIA, payload: id });

  axios
    .delete(`/api/user/media/deleteMedia/${id}`)
    .then((res) => {
      // Deleted media successfully
    })
    .catch((err) => {
      console.error("Unable to delete media: ", err);
      dispatch({ type: SET_ERRORS, payload: err });
    });
};

export const toggleTemplateFavorite = (templateId) => (dispatch) => {
  dispatch({ type: TOGGLE_TEMPLATE_FAVORITE, payload: templateId });

  axios
    .post("/api/user/templates/toggleTemplateFavorite", { templateId })
    .then((res) => {
      // Success
    })
    .catch((err) => {
      console.error("Unable to toggle template favorite: ", err);
      dispatch({ type: SET_ERRORS, payload: err });
    });
};

export const schedulePost =
  (
    post,
    activeProfileUsername,
    selectedBoards,
    designColors,
    isBulkScheduling
  ) =>
  (dispatch, getState) => {
    console.log("Scheduling post: ", post.postIndex);

    return new Promise((resolve, reject) => {
      if (!isBulkScheduling) {
        dispatch(
          updateSinglePost(post.postIndex, {
            isScheduled: false,
            isScheduling: true,
            error: "",
          })
        );
      }

      // Get user credentials from state for whitelisting status
      const state = getState();
      const userCredentials = state.user.credentials;

      let smallPost = preparePostForRendering(
        post,
        designColors,
        userCredentials
      );

      if (post.mediaType == "image") {
        axios
          .post("/highMemLimitApi/scraping/renderTemplateImage", smallPost)
          .then(async (imageURLRes) => {
            let downloadURL = imageURLRes.data;

            // Prepare the alt text only for platforms that support it
            const state = getState();

            // Import platform support utility
            const {
              platformSupportsAltText,
            } = require("../../utils/platformConfigs");

            let altText = "";
            if (platformSupportsAltText(post.template.platform)) {
              altText = await dispatch(
                prepareAltText(
                  post.altText,
                  state.design.generateAltTextWithAI,
                  state.design.aiLanguage,
                  downloadURL
                )
              );
            }

            // Loop through each selected board and create a post for each board
            let postPromises = [];

            // For platforms that don't use boards (like X and Facebook), create a single post
            if (
              selectedBoards.length === 0 &&
              (post.template.platform === "x" ||
                post.template.platform === "facebook" ||
                post.template.platform === "instagram" ||
                post.template.platform === "linkedin")
            ) {
              // Create single post
              let accessToken;
              let activeProfile = null; // Declare activeProfile in outer scope

              if (post.template.platform === "x") {
                // X tokens are now managed server-side - no access_token needed
                accessToken = null; // Backend will fetch from database
              } else if (post.template.platform === "facebook") {
                // For Facebook, get token from active profile
                const state = getState();
                const facebookProfiles =
                  state.user.authorizedSocialMediaProfiles?.facebook || [];
                activeProfile = facebookProfiles.find(
                  (profile) => profile.username === activeProfileUsername
                );
                accessToken = activeProfile?.authToken?.access_token;
              }

              postPromises.push(
                axios.post("/api/scheduling/schedulePost", {
                  access_token: accessToken,
                  title: post.title,
                  description: post.description,
                  altText: altText,
                  url: post.url,
                  imageURL: downloadURL,
                  boardId: null, // X and Facebook don't use boards
                  sectionId: null,
                  boardName: null,
                  // Multi-platform fields
                  platform: post.template.platform,
                  socialMediaProfileUsername:
                    post.socialMediaProfileUsername || activeProfileUsername,
                  mediaURL: downloadURL,
                  mediaType: "image",
                  scheduledTime: post.scheduledTime,
                  type: post.scheduledTime ? "SpecificDate" : "Queue",
                  media_source: {
                    source_type: "image_url",
                    url: downloadURL,
                  },
                  // Store the current includeURLInPostText setting with the scheduled post
                  includeURLInPostText: getState().design.includeURLInPostText,
                  // Add Facebook-specific data
                  ...(post.template.platform === "facebook" && {
                    platformSpecificData: {
                      pageId:
                        activeProfile?.platformUserId ||
                        activeProfile?.platformSpecificData?.pageId,
                    },
                  }),
                })
              );
            } else {
              // Original board-based logic for Pinterest and other platforms
              selectedBoards.forEach((board) => {
                if (board.type && board.type == "section") {
                  board.id = board.boardId;
                }

                // Add promise to array
                postPromises.push(
                  axios.post("/api/scheduling/schedulePost", {
                    // No access_token needed - backend fetches from database
                    title: post.title,
                    description: post.description,
                    altText: altText,
                    url: post.url,
                    imageURL: downloadURL,
                    boardId: board.id,
                    sectionId:
                      board.type && board.type == "section"
                        ? board.sectionId
                        : null,
                    boardName: board.name,
                    // Multi-platform fields
                    platform: post.template.platform || "pinterest",
                    socialMediaProfileUsername:
                      post.socialMediaProfileUsername || activeProfileUsername,
                    mediaURL: downloadURL,
                    mediaType: "image",
                    scheduledTime: post.scheduledTime,
                    type: post.scheduledTime ? "SpecificDate" : "Queue",
                    media_source: {
                      source_type: "image_url",
                      url: downloadURL,
                    },
                    // Store the current includeURLInPostText setting with the scheduled post
                    includeURLInPostText:
                      getState().design.includeURLInPostText,
                  })
                );
              });
            }

            return Promise.all(postPromises);
          })
          .then((postResArray) => {
            dispatch(
              incrementUsedPostCreditsInReduxState(
                postResArray.length * creditUsage.image
              )
            );

            dispatch(
              updateSinglePost(post.postIndex, {
                isScheduled: true,
                isScheduling: false,
                error: "",
              })
            );

            resolve();
          })
          .catch((err) => {
            console.error("Unable to schedule post: ", err);

            let error = "";

            if (err.response) {
              if (
                err.response &&
                err.response.status &&
                err.response.status == 503
              ) {
                error = `Please try again - Error 503`;
              } else {
                error = `${err.response.status} - ${err.response.data}`;
              }
            } else {
              error = "Unable to schedule post: " + err;
            }

            dispatch(
              updateSinglePost(post.postIndex, {
                isScheduled: false,
                isScheduling: false,
                error: error,
              })
            );

            reject(err);
          });
      }
    });
  };

export const sendEmailVerificationLink = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/user/sendEmailVerificationLink")
      .then((res) => {
        resolve("Email verification link sent");
      })
      .catch((err) => {
        console.error("Unable to send email verification link: ", err);
        reject("Unable to send email verification link");
      });
  });
};

export const verifyUserEmail = (uid) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/user/verifyUserEmail", { uid })
      .then((res) => {
        resolve("Email verified");
      })
      .catch((err) => {
        console.error("Unable to verify email: ", err);
        reject("Unable to verify email");
      });
  });
};

export const createDraft =
  (posts, name = null) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/user/drafts/createDraft", {
          posts,
          name: name == null ? "Autosave" : name,
          date: new Date().toISOString(),
        })
        .then((res) => {
          dispatch({ type: PREPEND_DRAFT, payload: res.data });
          resolve();
        })
        .catch((err) => {
          console.error("Unable to create draft: ", err);
          dispatch({ type: SET_ERRORS, payload: err });
          reject(
            "Unable to create draft. " +
              (err?.response?.data?.error ?? err?.message ?? "Please try again.")
          );
        });
    });
  };

export const updateDraft =
  (posts, draftId, name = null) =>
  (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/user/drafts/updateDraft", {
          posts,
          draftId,
          name: name == null ? new Date().toLocaleString() : name,
          date: new Date().toISOString(),
        })
        .then((res) => {
          resolve();
        })
        .catch((err) => {
          console.error("Unable to update draft: ", err);
          const serverError = err.response?.data?.error;
          const errorMessage =
            serverError ||
            "Unable to update draft. Your draft may be too large to save.";
          dispatch({ type: SET_ERRORS, payload: { error: errorMessage } });
          reject(errorMessage);
        });
    });
  };

// Module-level variable to track the current autosave draft ID.
// This lets autosaveDraft UPDATE the existing draft instead of creating duplicates.
let _autosaveDraftId = null;

// Loads the latest draft posts from the database into posts
export const loadLatestDraft = () => (dispatch) => {
  axios
    .get("/api/user/drafts/latestDraft")
    .then((res) => {
      let { posts, name, date, id } = res.data;

      // Only capture the draft ID for autosave if it's actually an Autosave draft,
      // so we don't accidentally overwrite manually-named drafts
      if (id && name === "Autosave") {
        _autosaveDraftId = id;
      }

      if (posts && posts.length > 0) {
        dispatch({
          type: SET_POSTS,
          payload: posts,
        });
      }
    })
    .catch((err) => {
      // 404 = no drafts yet, which is normal for new users
      if (err.response && err.response.status !== 404) {
        console.error("Unable to load drafts: ", err);
      }
    });
};

// Autosave: uses updateDraft if we know the draft ID from this session,
// otherwise calls createDraft which handles deduplication on the backend.
export const autosaveDraft = (posts) => (dispatch) => {
  const date = new Date().toISOString();

  if (_autosaveDraftId) {
    return axios
      .post("/api/user/drafts/updateDraft", {
        posts,
        draftId: _autosaveDraftId,
        name: "Autosave",
        date,
      })
      .catch((err) => {
        console.error("Unable to update autosave draft, will create new: ", err);
        _autosaveDraftId = null;
      });
  } else {
    // Backend deduplication: createDraft with name "Autosave" will find
    // and update an existing Autosave draft if one exists for this user
    return axios
      .post("/api/user/drafts/createDraft", {
        posts,
        name: "Autosave",
        date,
      })
      .then((res) => {
        if (res.data && res.data.id) {
          _autosaveDraftId = res.data.id;
        }
      })
      .catch((err) => {
        console.error("Unable to create autosave draft: ", err);
      });
  }
};

export const loadDraft = (draftId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/user/drafts/getDraft/" + draftId)
      .then((res) => {
        let { posts, name, date } = res.data;

        if (posts.length > 0) {
          dispatch({
            type: SET_POSTS,
            payload: posts,
          });
        }

        resolve();
      })
      .catch((err) => {
        console.error("Unable to load drafts: ", err);
        reject("Unable to load drafts");
      });
  });
};

// Clear unauthorized batch access state
export const clearUnauthorizedBatchAccess = () => (dispatch) => {
  dispatch({
    type: SET_UNAUTHORIZED_BATCH_ACCESS,
    payload: null,
  });
};

// Load batch content from 4-week content generation
export const loadBatchContent = (batchId) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/generatedContent/batch/${batchId}`)
      .then((res) => {
        const { posts, status } = res.data;

        // Check if the batch is not completed
        if (status && status !== "completed") {
          console.error(
            `❌ Batch ${batchId} is not completed. Status: ${status}`,
            {
              status: res.data.status,
              processedPosts: res.data.processedPosts,
              totalPosts: res.data.totalPosts,
              error: res.data.error,
              processingPhase: res.data.processingPhase,
            }
          );

          // Clear the loading flag
          dispatch({
            type: SET_BATCH_CONTENT_LOADING,
            payload: false,
          });

          // Reject with a descriptive error
          const errorMessage =
            status === "failed"
              ? `Batch generation failed${
                  res.data.error ? `: ${res.data.error}` : ""
                }`
              : `Batch is still ${status}. Progress: ${
                  res.data.processedPosts || 0
                }/${res.data.totalPosts || 0}`;

          reject(new Error(errorMessage));
          return;
        }

        // Batch is completed - load the posts
        if (posts && posts.length > 0) {
          // Apply frontend fallbacks for posts missing templates or colors
          const hydratedPosts = applyBatchPostFallbacks(posts, getState);

          dispatch({
            type: SET_POSTS,
            payload: hydratedPosts,
          });
          console.log(
            `✅ Loaded ${hydratedPosts.length} posts from batch ${batchId}`
          );
        } else {
          console.warn(`⚠️ Batch ${batchId} is completed but has no posts`);
        }

        // Clear the loading flag now that we're done (whether we have posts or not)
        dispatch({
          type: SET_BATCH_CONTENT_LOADING,
          payload: false,
        });

        resolve(res.data);
      })
      .catch((err) => {
        console.error(`❌ Unable to load batch content ${batchId}:`, err);

        // Check if it's a 403 (unauthorized) error
        if (err.response && err.response.status === 403) {
          dispatch({
            type: SET_UNAUTHORIZED_BATCH_ACCESS,
            payload: batchId,
          });
          // Clear any existing posts to prevent showing unauthorized content
          dispatch({
            type: SET_POSTS,
            payload: [],
          });
        }

        // Clear the loading flag on error as well
        dispatch({
          type: SET_BATCH_CONTENT_LOADING,
          payload: false,
        });
        reject(err);
      });
  });
};

export const getDrafts = (lastDraftId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (lastDraftId == "None") {
      dispatch({
        type: SET_DRAFTS,
        payload: [],
      });
    }

    axios
      .get(`/api/user/drafts/getDrafts?lastDraftId=${lastDraftId}`)
      .then((res) => {
        if (lastDraftId == "None") {
          dispatch({
            type: SET_DRAFTS,
            payload: res.data,
          });
        } else {
          dispatch({
            type: APPEND_DRAFTS,
            payload: res.data,
          });
        }

        resolve(res.data.length); // Return the number of drafts retrieved for the infinite scroll
      })
      .catch((err) => {
        console.error("Unable to get drafts: ", err);
        reject("Unable to get drafts");
      });
  });
};

// Create delete draft and rename draft functions
export const deleteDraft = (draftId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .delete("/api/user/drafts/deleteDraft/" + draftId)
      .then((res) => {
        dispatch({
          type: DELETE_DRAFT,
          payload: draftId,
        });

        resolve();
      })
      .catch((err) => {
        console.error("Unable to delete draft: ", err);
        reject("Unable to delete draft");
      });
  });
};

export const renameDraft = (draftId, newName) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/user/drafts/renameDraft", {
        draftId,
        newName,
      })
      .then((res) => {
        dispatch({
          type: RENAME_DRAFT,
          payload: { draftId, newName },
        });

        resolve();
      })
      .catch((err) => {
        console.error("Unable to rename draft: ", err);
        reject("Unable to rename draft");
      });
  });
};

// Delete user account
export const deleteUserAccount = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .delete("/api/user/deleteUserAccount")
      .then((res) => {
        dispatch(logoutUser());
        resolve();
      })
      .catch((err) => {
        console.error("Unable to delete user account: ", err);
        reject("Unable to delete user account");
      });
  });
};

export const setOnboardingChecklist = (checklist) => (dispatch) => {
  dispatch({ type: SET_ONBOARDING_CHECKLIST, payload: checklist });

  axios
    .post("/api/user/setOnboardingChecklist", checklist)
    .then((res) => {
      // Success
    })
    .catch((err) => {
      console.error("Unable to set onboarding checklist: ", err);
      dispatch({ type: SET_ERRORS, payload: err });
    });
};

export const recordReferral = (referralCode) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/referrals/recordReferral", { referralCode })
      .then((res) => {
        resolve("Referral recorded successfully");
      })
      .catch((err) => {
        console.error("Unable to record referral: ", err);
        reject("Unable to record referral");
      });
  });
};
